import React from 'react'

import FourOhFour from '@scoir/page-frame-components/dist/components/FourOhFour'
import PropTypes from 'prop-types'
import { Route, withRouter } from 'react-router-dom'

export const FourOhFourRoute = ({ history }) => (
  <Route render={() => <FourOhFour onGoHome={() => history.replace(`${import.meta.env.BASE_URL}/home`)} />} />
)

FourOhFourRoute.propTypes = {
  history: PropTypes.object.isRequired,
}

export default withRouter(FourOhFourRoute)
